export default {
  namespaced: true,
  state: {
    caseLists: [],
    count: 0,
    reportCaseID: null,
  },
  getters: {
    caseLists: (state) => state.caseLists,
    count: (state) => state.count,
    reportCaseID: (state) => state.reportCaseID,
  },
  mutations: {
    caseLists: (state, payload) => (state.caseLists = payload),
    count: (state, payload) => (state.count = payload),
    reportCaseID: (state, payload) => (state.reportCaseID = payload),
  },
  actions: {
    list({ commit }, queryParams) {
      return this.$apiService
        .get("/case-lists", {
          params: queryParams,
        })
        .then((res) => {
          commit("caseLists", res?.data?.data ?? []);
          commit("count", res?.data?.total ?? 0);
          return res;
        });
    },
    create({}, payload) {
      return this.$apiService.post("/case-lists", payload);
    },
    show({}, payload) {
      const id = typeof payload === "object" ? payload.id : payload;
      const params =
        typeof payload === "object" && payload.isShow != null
          ? { isShow: payload.isShow }
          : undefined;
      return this.$apiService.get(`/case-lists/${id}`, { params });
    },
    update({}, { id, data }) {
      return this.$apiService.put(`/case-lists/${id}`, data);
    },
    dashboard({}, queryParams) {
      return this.$apiService.get(`/backoffice-dashboard`, {
        params: queryParams,
      });
    },
    updateFlag({}, payload) {
      return this.$apiService.post("/update-flags", payload);
    },
    updateCaseStatus({}, payload) {
      return this.$apiService.post("/update-case-status", payload);
    },
    updateStatuses({}, payload) {
      return this.$apiService.post("/update-statuses", payload);
    },
    updateStatus({}, payload) {
      return this.$apiService.post("/update-status", payload);
    },
    updateAssignee({}, payload) {
      return this.$apiService.post("/update-assignee", payload);
    },
    updateResultStatus({}, payload) {
      return this.$apiService.post("/update-result-status", payload);
    },
    approveRejectCase({}, payload) {
      return this.$apiService.post("/approve-case", payload);
    },
    approveStatuses({}, payload) {
      return this.$apiService.post("/approve-cases", payload);
    },
    replicateCase({}, payload) {
      return this.$apiService.post("/requeue-case", payload);
    },
    deleteJaw({}, payload) {
    return this.$apiService.post("/delete-jaw", payload);
    },
    restoreJaw({}, payload) {
      return this.$apiService.post("/restore-jaw", payload);
    },
    // lockCase({}, { id, data }) {
    //   return this.$apiService.post(`/cases/lock/${id}`, data);
    // },
    // unlockCase({}, id) {
    //   return this.$apiService.post(`/cases/unlock/${id}`);
    // },
    deleteCases({}, payload) {
      return this.$apiService.post("/delete-cases", payload);
    },
    emptyTrash({}) {
      return this.$apiService.post("/empty-trash");
    },
    getMultipleResults({}, { id, data }) {
      return this.$apiService.get(`/get-multiple-results/${id}`, {
        params: data,
      });
    },
    destroyResult({}, { id, payload}) {
      return this.$apiService.post(`/case-results/${id}`, payload);
    },
    getLogs({}, { id, data }) {
      return this.$apiService.get(`/case-logs/${id}`, { params: data });
    },
    destroy({}, id) {
      return this.$apiService.delete(`/case-lists/${id}`);
    },
    getCreditCosts({}) {
      return this.$apiService.get(`/get-global-configuration`);
    },
    saveRating({}, payload) {
      return this.$apiService.post("/save-rating", payload);
    },
    saveResults({}, payload) {
      return this.$apiService.post("/save-results", payload);
    },
    parseFile({}, payload) {
      return this.$apiService.post("/parse-teeth-file", payload);
    },
    saveMultipleResults({}, payload) {
      return this.$apiService.post("/save-multiple-results", payload);
    },
    saveFiles({}, payload) {
      return this.$apiService.post("/save-files", payload);
    },
    sendMail({}, id) {
      return this.$apiService.post(`/send-approve-mail/${id}`);
    },
    saveCaseFeedback({}, payload) {
      return this.$apiService.post("/save-case-feedback", payload);
    },
    uploadConstructionInfoFile({}, { id, data }) {
      return this.$apiService.post(`/upload-constructioninfo-file`, data);
    },
    destroy({}, id) {
      return this.$apiService.delete(`/case-lists/${id}`);
    },
    startProcessing({}, payload) {
      return this.$apiService.post("/start-processing", payload);
    },
  },
};
